import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface ProjectStats {
  artifact_coverage_pct: number;
  gate_pass_rate: { pass_count: number; fail_count: number; pending_count: number };
  adoption: { active_member_count: number; members: { member_id: string; last_active: string }[] };
}

export function useProjectStats(slug: string) {
  const query = useQuery({
    queryKey: queryKeys.projects.stats(slug),
    queryFn: () => api<ProjectStats>(`/api/v2/projects/${slug}/stats`),
    enabled: slug.length > 0,
  });

  return {
    stats: query.data ?? null,
    loading: query.isLoading,
    error: query.error ? "Failed to load project stats" : "",
  };
}
